module.exports = {
  plugins: [
    {
      // site will not build without a valid
      // airtable api key; delete this plugin
      // if airtable isn't going to be used.
      resolve: `gatsby-source-airtable`,
      options: {
        apiKey: process.env.AIRTABLE_API_KEY,
        concurrency: 5,
        tables: [
          {
            baseId: `appwDmqz3Zvq5pLcP`,
            tableName: `Index page`,
            mapping: { Image: `fileNode` },
            tableView: `CMS view`,
          },
          {
            baseId: `appwDmqz3Zvq5pLcP`,
            tableName: `Nav`,
            mapping: { Image: `fileNode` },
            tableView: `CMS view`,
          },
          {
            baseId: `appwDmqz3Zvq5pLcP`,
            tableName: `Icons`,
            mapping: { SVG: `fileNode` },
            tableView: `CMS view`,
          },
          {
            baseId: `appwDmqz3Zvq5pLcP`,
            tableName: `FAQ`,
            mapping: { Image: `fileNode` },
            tableView: `CMS view`,
          },
          {
            baseId: `appwDmqz3Zvq5pLcP`,
            tableName: `About page`,
            mapping: { Image: `fileNode` },
            tableView: `CMS view`,
          },
          {
            baseId: `appwDmqz3Zvq5pLcP`,
            tableName: `Contact page`,
            mapping: { Image: `fileNode` },
            tableView: `CMS view`,
          },
          {
            baseId: `appwDmqz3Zvq5pLcP`,
            tableName: `Clients`,
            mapping: { Image: `fileNode` },
            tableView: `CMS view`,
          },
          {
            baseId: `appwDmqz3Zvq5pLcP`,
            tableName: `Forms`,
            mapping: { Image: `fileNode` },
            tableView: `CMS view`,
          },
          {
            baseId: `appwDmqz3Zvq5pLcP`,
            tableName: `Footer`,
            mapping: { Image: `fileNode` },
            tableView: `CMS view`,
          },
          {
            baseId: `appwDmqz3Zvq5pLcP`,
            tableName: `Site metadata`,
            mapping: { Image: `fileNode` },
            tableView: `CMS view`,
          },
        ],
      },
    },
    {
      // filling in the gtag here
      // will set up both the gatsby
      // google analytics plugin and
      // the cookieconsent opt-in system.
      resolve: `gatsby-plugin-gtag`,
      options: {
        trackingId: `G-XWCV7CQXMR`,
        anonymize: true,
        head: false,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'pages',
        path: './src/pages/',
      },
      __key: 'pages',
    },
    'talus-gatsby-transformer-svg',
    'gatsby-plugin-styled-components',
    'talus-gatsby-transformer-svg',
    'gatsby-plugin-react-helmet',
    'gatsby-transformer-sharp',
    'gatsby-plugin-sharp',
    'gatsby-plugin-image',
    'gatsby-plugin-mdx',
    'gatsby-plugin-root-import',
  ],
}
